var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('switch-field',{attrs:{"label":_vm.$t('Registration disabled')},model:{value:(_vm.registrationDisabled),callback:function ($$v) {_vm.registrationDisabled=$$v},expression:"registrationDisabled"}})}
var staticRenderFns = []

export { render, staticRenderFns }